/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useSettings } from '@/data/Settings';
import { ItnlIntegrationScript } from '@/data/types/ItnlIntegrationScript';
import { klarnaRefreshPlacement } from '@/utils/itnlIntegrationScriptsScripts';
import { loadExternalScripts, removeScripts } from '@/utils/loadExternalScripts';
import { Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';


export const KlarnaPDP:  FC<{ calculatedPrice?: string }> = ({
	calculatedPrice: calculatedPrice,
}) => {
	calculatedPrice = (parseFloat(calculatedPrice??'00')*100).toFixed(0);
	const { settings } = useSettings();
	const groupOtherPayment = settings.userData.GroupOtherPaymentTypes;
	let ifKlarnaexists: boolean= false;
	let scripts: ItnlIntegrationScript[] = [];
	const [loadScript, setLoadScript] = useState(false);
	const klarna_OnsiteMessagingEndPointURL = settings.userData.klarna_OnsiteMessagingEndPointURL;
	const klarna_OnsiteMessagingClientId= process.env.NEXT_PUBLIC_KLARNA_ONSITEMESSAGING_CLIENTID ?? '';

	if(groupOtherPayment.includes('KLARNA_PAY_LATER') || groupOtherPayment.includes('KLARNA_PAY_IN_3') || groupOtherPayment.includes('KLARNA')  ){
		ifKlarnaexists = true;
	}
	useEffect(() => {

		try {
			if (ifKlarnaexists) {
				scripts.push({
					id: "klarna_onsite_messaging",
					url: klarna_OnsiteMessagingEndPointURL,
					attrs: [['data-client-id', klarna_OnsiteMessagingClientId],['data-environment',settings.userData.klarnaenvironment]],
					onLoadScripts:[
						{
							id:"klarna_onsitemessaging",
							scriptContent:klarnaRefreshPlacement()
						}
					], 
					retainScript: true,
					skipIfExists: true
				})
				if (!loadScript)
					setLoadScript(true);
			}
		} catch (e) { console.log(e); }

		if (loadScript)
			loadExternalScripts(scripts);
		return () => { removeScripts(scripts) }
	}, [loadScript, ifKlarnaexists]);


	const klarnaPlacement = '<div class="klarnaOSMDiv" id ="klarnaOSMDivId"><klarna-placement class="custom-button-osm" data-key="credit-promotion-auto-size"  data-locale="nl-NL" data-purchase-amount="' +calculatedPrice + '"></klarna-placement></div>';
	return (
		ifKlarnaexists ?
			<>		
				<Stack dangerouslySetInnerHTML={{ __html: klarnaPlacement }} width="100%" mt={'24px !important'} mb={'8px !important'} />
			</> : null

	);
};